module.exports = __webpack_public_path__ + "img/case02.03aeb01c.jpg";